<template>
  <div class="mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-arrow-to-right text-orange"
            icon-size="17px"
            title="Facilitar"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="types"
              label="Tipo de facilidad:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione un tipo de facilidad"
              :error="errors[0]"
              v-model="model.type"
              :disabled="isAssigned || isLoan"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="reasons"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            :rules="isStudentRequired ? 'required' : ''"
            v-if="!hasStudentSaved"
          >
            <custom-auto-complete
              v-model="model.student"
              label="Nombre del Estudiante:"
              ref="autocompleteRef"
              placeholder="Nombre del Estudiante o Numero de SIE"
              v-on="$listeners"
              :debounce-time="2000"
              :get-result-value="getResultValue"
              :search="searchAutoCompleteHandler"
              :class="'w-100'"
              @changed="handleOnChange"
              @submit="handleSubmit"
            />
            <error
              v-if="invalidStudent || errors[0]"
              variant="no-border"
              message="Estudiante requerido o inválido"
            />
          </validation-provider>
          <div v-else>
            <custom-input
              label="Nombre del Estudiante:"
              labelClass="data-name"
              v-model="model.student.fullName"
              disabled
              icon="fas fa-search text-orange"
              left-icon
            />
          </div>
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider v-slot="{ errors }" mode="eager">
            <custom-drop-down
              :options="centers"
              label="Centro:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione un caat"
              :error="errors[0]"
              v-model="model.caat"
            />
          </validation-provider>
        </div>
        <div
          v-if="showReturnDate"
          class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12"
        >
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              required
              v-model="model.returnDate"
              :max-date="maxDate"
              :min-date="minDate"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-container"
              container-class="w-100"
              :error="errors[0]"
              :custom-error-msg="'La fecha es requerida'"
              label="Fecha de Devolución:"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-lg-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="completePhone"
            :custom-messages="{
              completePhone: 'Favor de ingresar 10 dígitos numéricos.'
            }"
          >
            <custom-input
              label="Número de Contacto:"
              labelClass="data-name"
              placeholder="(000) 000-0000"
              mask-type="Phone"
              v-model="model.phone"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </validation-provider>
        </div>

        <div class="col-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
              show-char-count
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import CustomDropDown from "custom-drop-down";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomInput from "CustomInput";
import CustomDatePicker from "custom-date-picker";
import { CustomAutoComplete } from "@/components/common";
import Error from "custom-error";

import reasonTypes from "@/utils/constants/inventory/reasonTypes";
import StudentStatuses from "@/utils/constants/reg/studentStatuses.js";
import peiAtServiceEquipmentStatus from "@/utils/constants/inventory/peiAtServiceEquipmentStatus";
import typeFacility from "@/utils/constants/inventory/typeFacility";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import locationService from "@/services/api/location.api";

export default {
  name: "Loan",
  components: {
    IconView,
    ActionButton,
    CustomDropDown,
    CustomTextArea,
    CustomInput,
    CustomDatePicker,
    CustomAutoComplete,
    Error
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    centers: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      caats: [],
      reasons: [],
      types: [],
      model: {
        type: null,
        studentName: "",
        comment: "",
        caat: null,
        reason: null,
        returnDate: null,
        student: null,
        phone: "",
        expedient: ""
      },
      searchStudentSnapshot: {
        data: []
      },
      students: [],
      selectedStudent: null,
      invalidStudent: false,
      studentSaved: null
    };
  },
  computed: {
    maxDate() {
      let currentDate = new Date();
      let futureDate = new Date(currentDate);
      return futureDate.setMonth(futureDate.getMonth() + 10);
    },
    minDate() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    showReturnDate() {
      return this.model.type && this.model.type.id == typeFacility.AUXILIAR;
    },
    isAssigned() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Assigned;
    },
    isLoan() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Loan;
    },
    hasStudentSaved() {
      return Boolean(this.studentSaved);
    },
    isStudentRequired() {
      return this.model?.type?.id != typeFacility.DONACION;
    }
  },
  async mounted() {
    Promise.all([this.getReasons(), this.getTypes()]);
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid || this.invalidStudent) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      if (!this.model.student && this.isStudentRequired) {
        this.ShowToast(
          "Alerta",
          "Por favor selecciona un estudiante.",
          "error"
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!isConfirmed) {
        return;
      }

      const payload = {
        ...this.model,
        equipmentId: this.item.id,
        caatId: this.model?.caat?.id,
        reasonId: this.model.reason.id,
        studentSieId: this.model?.student?.studentSieId,
        returnDate: this.showReturnDate ? this.model.returnDate : null,
        typeFacilityId: this.model.type.id
      };

      this.$emit("save", payload);
    },
    async getReasons() {
      const { data } = await inventoryCatalogService.getReasonsByType(
        reasonTypes.Facilitate
      );
      this.reasons = data;
    },
    async getTypes() {
      const { data } = await inventoryCatalogService.getTypeFacilities();
      this.types = data;

      if (this.isAssigned || this.isLoan) {
        this.model.type = this.types.find(
          ({ id }) => id === typeFacility.DONACION
        );
        this.getStudent();
      }
    },
    async getStudent() {
      const { data } = await inventoryCatalogService.getStudentFromLoan(
        this.item.id
      );

      if (data) {
        const student = {
          fullName: data.name,
          studentSieId: data.id
        };

        this.model.student = student;
        this.studentSaved = student;
      }
    },
    searchAutoCompleteHandler(input) {
      return new Promise(resolve => {
        if (input.length < 4) {
          return resolve([]);
        }

        if (input == this.searchStudentSnapshot.input) {
          return resolve(this.searchStudentSnapshot.data);
        }
        this.searchStudentSnapshot.input = input;
        inventoryCatalogService
          .getStudents(input)
          .then(({ data: response }) => {
            this.students = [];

            this.students = response.map(student => {
              return {
                ...student,
                userName: student.status,
                email: student.studentSieId
              };
            });

            this.searchStudentSnapshot.data = this.students;
            resolve(this.searchStudentSnapshot.data);
          });
      });
    },
    getResultValue(result) {
      return result.fullName;
    },
    handleOnChange(val) {
      this.model.student = val.fullName;
      if (!val) {
        this.searchStudentSnapshot.input = null;
      }
    },
    async handleSubmit(val) {
      if (val.statusId == StudentStatuses.Egreso) {
        this.invalidStudent = true;
        this.ShowToast(
          "Alerta",
          "Este estudiante se encuentra en estatus de egreso y no valido para facilitar un equipo.",
          "error"
        );
        return;
      }
      this.invalidStudent = false;
      this.model.student = val;
      this.searchStudentSnapshot.input = val.fullName;
      this.searchStudentSnapshot.fullName = val.fullName;
      this.searchStudentSnapshot.studentSieId = val.studentSieId;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}
::v-deep .form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #ff7058;
  margin-right: 0.2rem;
}
</style>
